export const companyAdminRoutes = [];
